import { Alert } from "@zapier/design-system";
import styles from "./UpgradeAlert.module.css";

export interface UpgradeAlertProps {
  title: string;
}

export const UpgradeAlert: React.FC<UpgradeAlertProps> = ({ title }) => {
  return (
    <div className={styles.wrapper}>
      <Alert title={title} status="warning" />
    </div>
  );
};
